import {
    AREA_DATA_FIELD,
    BAR_CHART,
    BUILDING_DATA_FIELD,
    COST_DATA_FIELD,
    COST_SUMMARY_REPORT_TITLE,
    COUNT_FIELD,
    DEPLOYMENT_STATUS_FIELD,
    DEVICE_TYPE_FIELD,
    DNS_NAME_FIELD,
    IP_ADDRESS_FIELD,
    MANUFACTURER_FIELD,
    MODEL_FIELD,
    NAME_DATA_FIELD,
    ROOM_DATA_FIELD,
    TABLE_ID,
    TOTAL_COST_FIELD,
    UPDATED_AT_DATA_FIELD
} from "../../constants/reports_constants";
import ReportGenerator from "./report_generator";
import {
    deviceCostValue,
    getLocaleStringLocale,
    getLocaleStringOptions
} from "../charts/data_factories/value_function";

export default class CostSummaryReportGenerator extends ReportGenerator {

    _getGraphTitle() {
        return COST_SUMMARY_REPORT_TITLE;
    }

    _hideUnusedColumns() {
        this._hideColumn(AREA_DATA_FIELD);
        this._hideColumn(ROOM_DATA_FIELD);
        this._hideColumn(UPDATED_AT_DATA_FIELD);
        this._hideColumn(NAME_DATA_FIELD);
        this._hideColumn(IP_ADDRESS_FIELD);
        this._hideColumn(DNS_NAME_FIELD);
    }

    _showUsedColumns() {
        this._showColumn(DEVICE_TYPE_FIELD);
        this._showColumn(MANUFACTURER_FIELD);
        this._showColumn(MODEL_FIELD);
        this._showColumn(BUILDING_DATA_FIELD);
        this._showColumn(COST_DATA_FIELD);
        this._showColumn(COUNT_FIELD);
        this._showColumn(DEPLOYMENT_STATUS_FIELD);
        this._showColumn(TOTAL_COST_FIELD);
    }

    _getChartType() {
        return BAR_CHART;
    }

    /**
     * This method is overwritten so each row in the table can be an aggregate of many devices.
     * In this case, we aggregate by device model, building, and deployment status
     * @param devices an array of device metadata, as JSON
     * @private
     */
    _tableAggregator(devices) {
        // Use a Map to aggregate devices by [building, model, deployment status]
        // This works correctly whether devices arrive all at once or in batches
        const aggregationMap = new Map();

        // Loop through each device and aggregate by key
        for (const device of devices) {
            // Grab the device's model id, if it has one. If it doesn't, we'll aggregate costs at the device
            // Get type ID - either model ID for devices or part type ID for parts
            let typeId = device?.device?.model?.id || device?.part?.part_type?.id;
            let buildingId = device?.locale?.building?.id;
            let deploymentStatusId = device?.deployment_status?.id || ''

            // Generate the ID used in this table
            let id = `${ buildingId }!${ typeId }!${ deploymentStatusId }`

            if (aggregationMap.has(id)) {
                // Update existing aggregation
                const aggregatedRow = aggregationMap.get(id);
                aggregatedRow.count = aggregatedRow.count + 1;
                aggregatedRow.total_cost = (aggregatedRow.count * deviceCostValue(device)).toLocaleString(getLocaleStringLocale(), getLocaleStringOptions());
            } else {
                // Create new aggregation entry
                aggregationMap.set(id, {
                    id: id,
                    device: {
                        device_type: {
                            name: device?.device?.device_type?.name || device?.part?.part_type?.name
                        },
                        manufacturer: {
                            name: device?.device?.manufacturer?.name || '',
                        },
                        model: {
                            name: device?.device?.model?.name || '',
                            cost: device?.device?.model?.cost || device?.part?.part_type?.cost
                        }
                    },
                    deployment_status: {
                        name: device?.deployment_status?.name || '',
                    },
                    locale: device['locale'],
                    count: 1,
                    total_cost: deviceCostValue(device)
                        .toLocaleString(getLocaleStringLocale(), getLocaleStringOptions())
                });
            }
        }

        // Convert aggregation map to array
        const aggregatedRows = Array.from(aggregationMap.values());

        // Use argus--table
        const argus = this._getArgusTable()
        if (argus) {
            argus.loadData(aggregatedRows)
        }
    }
}